<mat-card [hidden]="!employees || employees?.data?.length < 1" class="trip-table table-card total-table-border">
	<mat-card-title fxLayout="row" fxLayoutAlign="start center">
		<h5 class="readonly-label ml-2">Employees</h5>
	</mat-card-title>
	<div>
		<div fxLayout fxLayoutAlign="start center" class="mb-2 ml-2 mt-xs">
			<mat-form-field fxFlex="40%">
				<input matInput type="text" [(ngModel)]="filterText" (keyup)="filterEmployees()" placeholder="Filter" />
				<button
					*ngIf="filterText"
					mat-icon-button
					matSuffix
					(click)="filterText = ''; filterEmployees()"
					[attr.aria-label]="'Clear'"
				>
					<mat-icon>close</mat-icon>
				</button>
			</mat-form-field>
			<mat-slide-toggle class="ml-2" [(ngModel)]="hiddenFromList" (change)="hiddenFromListFilter()" color="warn"
				>Hidden Employees</mat-slide-toggle
			>
		</div>
		<mat-card-title>
			<mat-list class="trip-card-header">
				<mat-list-item>
					<h5 class="mt-0">Employees</h5>
				</mat-list-item>
			</mat-list>
		</mat-card-title>
		<table
			mat-table
			[dataSource]="employees"
			class="trip-table"
			matSort
			matSortActive="lastName"
			matSortDirection="asc"
		>
			<ng-container matColumnDef="lastName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Pilot</strong></th>
				<td mat-cell *matCellDef="let element">
					<a class="override-link" (click)="openOverrideEmployeeDialog(element)"
						>{{ element.firstName }} {{ element.lastName }}</a
					>
				</td>
			</ng-container>

			<ng-container matColumnDef="emailAddress">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Email Address</strong></th>
				<td mat-cell *matCellDef="let element">
					{{ element.emailAddress }}
				</td>
			</ng-container>

			<ng-container matColumnDef="phoneStipend" >
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Phone Stipend</strong></th>
				<td mat-cell *matCellDef="let element">
					<i
						*ngIf="element.receivesPhoneStipend === true"
						class="fa fa-check color-black icon-center"
						aria-hidden="true"
						matTooltip="Yes"
						matTooltipPosition="right"
					></i>
				</td>
			</ng-container>

			<ng-container matColumnDef="jobTitle">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Job Title</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.jobTitleName }}</td>
			</ng-container>
			<ng-container matColumnDef="aircraftModel">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Aircraft Model</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.aircraftModelName }}</td>
			</ng-container>

			<ng-container matColumnDef="newJobTitle">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>New Job Title</strong></th>
				<td mat-cell *matCellDef="let element">
					<span *ngIf="element.scheduledChanges">{{ element.scheduledChanges.jobTitleName }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="newAircraftModel">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>New Aircraft Model</strong></th>
				<td mat-cell *matCellDef="let element">
					<span *ngIf="element.scheduledChanges">{{ element.scheduledChanges.aircraftModelName }} </span>
				</td>
			</ng-container>

			<ng-container matColumnDef="effectiveDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Changes Effective on</strong></th>
				<td mat-cell *matCellDef="let element">
					<span *ngIf="element.scheduledChanges">{{ element.scheduledChanges.effectiveStart | date }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="employmentStatus">
				<th mat-header-cell *matHeaderCellDef><strong>Employment Status</strong></th>
				<td mat-cell *matCellDef="let element">
					<i
						*ngIf="element.employmentStatus === employmentStatuses.Active"
						class="fa fa-circle color-green-deep icon-center"
						aria-hidden="true"
						matTooltip="Active"
						matTooltipPosition="right"
					></i>
					<i
						*ngIf="element.employmentStatus === employmentStatuses.LeaveOfAbsence"
						class="fa fa-circle color-orange-deep icon-center"
						aria-hidden="true"
						matTooltip="Leave Of Absence"
						matTooltipPosition="right"
					></i>
					<i
						*ngIf="element.employmentStatus === employmentStatuses.Terminated"
						class="fa fa-circle color-red icon-center"
						aria-hidden="true"
						matTooltip="Terminated"
						matTooltipPosition="right"
					></i>
				</td>
			</ng-container>

			<tr class="pilots-table-header" mat-header-row *matHeaderRowDef="displayedEmployeesColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedEmployeesColumns"></tr>
		</table>

		<div *ngIf="isLoading" class="loading-container"></div>
	</div>
</mat-card>
